import {useStatic} from "@/store/static"

export const processes: TableModule = {
    name: "processes",
    route: "spa.processes.processes",
    defaultOrder: {
        column: "id",
        direction: "desc"
    },
    columns: [
        {
            name: "process_number",
            sortable: true,
            pageLink: true,
            sortBy: "customOrderProcessNumber",
            mobile: true,
            width: "w-[170px]",
        }, {
            name: "sl_number",
            sortable: true,
            sortBy: "customOrderSlNumber",
            hidden: true,
        }, {
            name: "organisation",
            sortable: true,
            sortBy: "organisation_id",
            width: "w-1/4 sm:w-auto",
            breakpoint: 'lg',
        }, {
            name: "funding_program",
            sortable: true,
            sortBy: "funding_program_id",
            breakpoint: 'lg',
        }, {
            name: "event",
            sortable: true,
            sortBy: "processes.start_date",
            breakpoint: 'xl',
        }, {
            name: "subsidy_due",
            sortable: true,
            sortBy: "subsidy_open_payment",
            width: "w-[115px]"
        }, {
            name: "formProcesses",
            width: "w-[100px]"
        }, {
            name: "status",
            sortable: true,
            sortBy: "status_id",
            width: "w-[150px]"
        }, {
            name: "started_at",
            sortable: true,
            hidden: true,
        }, {
            name: "symbols",
            mobile: true,
            width: "min-w-[100px]",
            headerClass: "block sm:hidden",
            cellClass: "min-w-[100px] block sm:hidden"
        }
    ],
    filters: [
        {
            name: "sl_number",
            column: "processes.sl_number",
            type: "numeric",
            reduced: "[,]",
        }, {
            name: "year",
            column: "processes.year_id",
            type: "select",
            options: computed(() => {
                const staticStore = useStatic()
                return reactive(staticStore?.years?.map((year: any) => {
                    return {
                        value: year.id,
                        label: year.id
                    }
                }) || [])
            }),
            reduced: true,
        }, {
            name: "organisation",
            column: "processes.organisation_id",
            type: "searchSelect",
            apiRoute: "spa.settings.organisations.index",
            reduced: 'in',
            searchThreshold: 1,
            additionalDisplayKey: 'additionalInfo',
        }, {
            name: "customFilterTransferAgreement",
            column: "customFilterTransferAgreement",
            type: "boolean",
            reduced: 'in',
        }, {
            name: "fundingProgram",
            column: "customFilterFundingPrograms",
            type: "searchSelect",
            apiRoute: "spa.basedata.fundingPrograms.filterOptions",
            reduced: 'in',
            searchSelectConfig: {
                fetchOnSearch: false,
                orderBy: 'customOrderSortByParent',
                orderDirection: 'asc',
            }
        }, {
            name: "statusKey",
            column: "statuses.key",
            type: "processStatus",
            options: () => $lara.get(
                useNuxtApp().$apiRoute('spa.processes.processes.statuses.index')
            ).then(response => response.data?.map(
                status => ({
                    value: status.key,
                    label: status.name_management_area
                }))
            ),
            default: {
                operator: "in",
                value: ["a_review", "a_revise", "a_started", "a_started_digital", "a_received", "a_checked", "a_sent_rp", "a_granted", "v_review", "v_revise", "v_started", "v_started_digital", "v_received", "v_edited", "v_checked", "v_sent_rp", "v_sent_rp_digital", "v_granted", "paid_partially", "paid_fully", "withdrawn", "rejected"]
            },
            reduced: true,
            multiple: true
        }, {
            name: "customFilterHasOpenPayment",
            column: "customFilterHasOpenPayment",
            type: "boolean",
            reduced: true
        }, {
            name: "event",
            column: "events.id",
            type: "shortcut",
            relation: "event"
        }, {
            name: "eventEndDate",
            column: 'events.end_date',
            type: "date",
            relation: "event"
        }, {
            name: "association",
            column: "organisations.association_id",
            relation: "organisation",
            type: "searchSelect",
            apiRoute: "spa.settings.organisations.index",
            searchThreshold: 1,
            additionalDisplayKey: 'additionalInfo',
            searchSelectConfig: {
                filter: [{
                    column: "type",
                    operator: "=",
                    value: "association"
                }]
            },
            reduced: false,
        }
    ],
    quickFilters: [],
    tools: [
        {
            name: "processes.changeStatus",
            icon: "heroicons:chart-bar-square",
        }, {
            name: "processes.massApproval",
            icon: "heroicons:arrow-down-tray",
            ability: ["update", "processes"]
        }, {
            name: "processes.paymentRuns",
            icon: "heroicons:arrow-down-tray",
            ability: ["create", "payments"]
        }, {
            name: "processes.reporting",
            icon: "heroicons:chart-bar-square",
            ability: ["viewAny", "reporting"]
        }, {
            name: "processes.creatorUserMail",
            icon: "heroicons:envelope",
            ability: ["update", "processes"]
        }
    ],
    enableSaveFilters: true,
}